import { Hero, Intro } from '..';
import FatooraBanner from './FatooraBanner';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useEffect, useState } from 'react';
import { getCountry } from '../Api';

function Home() {
    const [isSaudi, setIsSaudi] = useState(null);

    useEffect(() => {
        getCountry().then((country) => {
            if (country === 'SA') setIsSaudi(true);
            else setIsSaudi(false);
        });
    }, []);
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Free Windows Point of Sale - Aronium</title>
                    <meta name="description" content="Free Windows Point of Sale. Easy to use, fast, modern and reliable retail system." />
                </Helmet>
            </HelmetProvider>
            {isSaudi && <FatooraBanner />}
            <Hero />
            <Intro />
        </>
    );
}

export default Home;